<template>
    <div class="card card-img-holder text-white" :class="type" :style="dashboardHeight">
        <div class="card-body p-3">
            <div class="d-flex">
                <div class="inner-content m-2">
                    <img
                        src="@/assets/images/icon/half-circle.svg"
                        class="card-img-absolute"
                        alt="circle-image"
                    />
                    <img
                        src="@/assets/images/icon/half-circle.svg"
                        class="circle-2"
                        alt="circle-image"
                    />
                    <img
                        :src="img"
                        alt="circle-image"
                        class="mb-2 icon-img"
                    />
                    <h3>{{ title }}</h3>
                </div>
                <div class="number-bar" :class="iconColor">{{ count || 0 }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
name: 'stats-card',
props: [
    'type',
    'count',
    'iconName',
    'iconColor',
    'title',
    'subTitle',
    'img',
    'dashboardHeight'
],
created() {
    console.log('type', this.type)
},
}
</script>
<style></style>
